import styled from 'styled-components';
export const PoText = styled.div`
    font-size: 14px;
    font-family: ${(props) =>
        props.fontFamily ? props.fontFamily : 'AvenirNextWorld Regular'};
    color: #202124;
`;
export const PoValue = styled.div`
    font-size: 14px;
    font-family: AvenirNextWorld Regular;
    color: #140f4b;
    word-break: ${(props) => props.wordBreak};
    margin-left : 2px
`;
